function Footer() {
  return (
    <div data-testid="Footer" className="Footer bg-[#FF1541]">
      <div
        data-testid="SectionContainer"
        className="SectionContainer mx-auto px-[10px] pb-[60px] pt-[20px] md:px-[20px] lg:px-[20px] xl:pt-0 !bg-red !min-h-[70px] !px-[10px] flex items-center !pb-[20px] min-h-screen max-w-[1440px]"
      >
        <p className="font-cairo sm:text-[15px] text-[14px] text-white">
          © Ballerz™ 2025{" "}
        </p>
      </div>
    </div>
  );
}

export default Footer;
